// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__niVck","emails":"CreateEditClinics_emails__1kR9f","emailTagLabel":"CreateEditClinics_emailTagLabel__3pPee"};